import axios from "axios";
import backendUrl from "./apiUrl";
import { isLoggedIn } from "../helpers/helpfulFunctions";
import { getCookie } from "../helpers/cookies";
import config from "../config";
import { useMemo } from "react";
import { shallowEqual, useSelector } from "react-redux";
import { ApplicationState } from "../reducers";
import { AxiosRequestConfig } from "axios";

const axiosClient = () =>
  axios.create({
    baseURL: backendUrl,
    responseType: "json",
    headers: {
      "X-Admin-Token": isLoggedIn() ? getCookie("token") : "",
      "Content-Type": "application/json",
      Accept: "application/json",
    },
  });

export const useSSOAxiosClient = () => {
  const token = useSelector(
    (state: ApplicationState) => state.auth.sso_token,
    shallowEqual
  );
  return useMemo(() => {
    const axiosInstance = axios.create({
      baseURL: `${config.SSO_BASE_API_URL}/api`,
      responseType: "json",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    });

    axiosInstance.interceptors.request.use((cfg: AxiosRequestConfig) => {
      cfg.headers.Authorization = `Bearer ${token}`;
      return cfg;
    });

    return axiosInstance;
  }, [token]);
};

export const useOAuthAxiosClient = () => {
  const axiosInstance = axios.create({
    baseURL: `${config.SSO_BASE_API_URL}/api`,
    responseType: "json",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: "Basic cGlsb3Q6NEM5WVtEZ3ZRUTVq",
    },
  });

  return axiosInstance;
};

export default axiosClient;
